import { render, staticRenderFns } from "./navbar-partner-link.vue?vue&type=template&id=33d61eeb&scoped=true"
import script from "./navbar-partner-link.vue?vue&type=script&lang=ts&setup=true"
export * from "./navbar-partner-link.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./navbar-partner-link.vue?vue&type=style&index=0&id=33d61eeb&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d61eeb",
  null
  
)

export default component.exports